import React from "react";
function MerchantHostedSeamless() {
  return (
    <div class="idocs-content">
      <div class="container">
        <div class="row">
          <div class="col-md-8">
            <section id="idocs_content" class="mt-20 mb-20">
              <h2>Merchant Hosted (Seamless)</h2>
              <hr />
            </section>

            <p>
              The <b className="para-blod">Safexpay</b> payment integration
              supports a seamless payment experience on your platform while
              protecting your application from payment fraud and complexity
              related to various regulations. You can develop and manage your
              checkout page.
            </p>

            <p>
              You can configure Cards, Net-banking, Wallets, etc. paymodes on
              your checkout page and send the customer’s payment request
              directly to the bank’s server via{" "}
              <b className="para-blod">Safexpay</b> integration.
            </p>

            <p>
              As per <b className="para-blod">PCI/DSS</b>, only companies with  <b className="para-blod"> PCI/DSS compliance</b> can collect/process the card details on their server.
              Due to this, if you are a PCI/DSS compliant company, only you can
              store/process/collect the card details on your platform.
            </p>


            <div className="img-div">
              <img src="assets/images/Devdoc2.png" alt="logo" />
            </div>

            {/* Merchant Hosted (Seamless) fig start */}

            {/* Merchant Hosted (Seamless) fig end */}

            <u>
              <h4>Process flow</h4>
            </u>

            <ul>
              <li>
                <p>
                  Customer selects product/service on your website and
                  proceedsto make payment.
                </p>
              </li>
              <li>
                <p>
                  Customer is redirected to the{" "}
                  <b className="para-blod">Safexpay</b> payment page where
                  payment information is entered by the customer.
                </p>
              </li>
              <li>
                <p>
                  On submission of the transaction information,{" "}
                  <b className="para-blod">Safexpay</b> initiates the
                  authorization process by connecting to the relevant bank /
                  processing organization.
                </p>
              </li>
              <li>
                <p>
                  .On receiving the authorization status from the bank,{" "}
                  <b className="para-blod">Safexpay</b> sends the response back
                  to your website with the transaction status.
                </p>
              </li>
            </ul>

            <section id="idocs_content" class="mt-20 mb-20">
              <h2>Safexpay Test Environments for Merchant Hosted(Seamless)</h2>
              <hr />
            </section>

            <table class="table table-bordered">
              <tbody className="table-bdy">
                <tr>
                  <td className="table-color">Post URL</td>
                  <td>
                    {/* <a href=" https://uatcheckout.safexpay.ae/ms-transaction-core-1-0/paymentRedirection/checksumGatewayPage">
                      https://uatcheckout.safexpay.ae/ms-transaction-core-1-0/paymentRedirection/checksumGatewayPage
                    </a> */}
                    <p>
                      {" "}
                      https://uatcheckout.safexpay.ae/ms-transaction-core-1-0/paymentRedirection/checksumGatewayPage
                    </p>
                  </td>
                </tr>
                <tr>
                  <td className="table-color">Merchant ID</td>
                  <td>202402140004</td>
                </tr>
                <tr>
                  <td className="table-color">Encryption Key</td>
                  <td>fsexZm+ZegioER1Gd1GbVbWH20xunn6WAgk5LlCBzYI=</td>
                </tr>
                <tr>
                  <td className="table-color">Aggregator ID</td>
                  <td> paygate</td>
                </tr>
              </tbody>
            </table>

            <u>
              <h4>Request Parameters</h4>
            </u>

            <p>
              Merchant must send the following parameters to{" "}
              <b className="para-blod">Safexpay</b> PG for processing an order.
            </p>

            <table class="table table-bordered">
              <tbody className="table-bdy">
                <tr className="table-main-title">
                  <th colSpan={7}>
                    Section: Txn_Details (Required Parameters)
                  </th>
                </tr>
                <tr className="table-color">
                  <th>Parameter Name</th>
                  <th>Mandate</th>
                  <th> Type (length)</th>
                  <th>Description</th>
                </tr>
                <tr>
                  <td>ag_id</td>
                  <td>YES</td>
                  <td>Alphabets (11)</td>
                  <td>Aggregator id is “paygate”</td>
                </tr>

                <tr>
                  <td>me_id</td>
                  <td>YES</td>
                  <td> Numeric (20)</td>
                  <td>MerchantID issued to you by Safexpay.</td>
                </tr>

                <tr>
                  <td>order_no</td>
                  <td>YES</td>
                  <td>Alphanumeric (70)</td>
                  <td>
                    {" "}
                    This ID is used by merchants to identify the order. Ensure
                    that you send a <b>unique id</b> with each request. As it
                    generates a unique payment reference number for each order
                    which is sent by the merchant.
                  </td>
                </tr>

                <tr>
                  <td>Amount</td>
                  <td>YES</td>
                  <td> Numeric (10,2)</td>
                  <td>
                    This is your Transaction Amount. You can use up to 2 decimal
                    places. E.g., “150.00”
                  </td>
                </tr>

                <tr>
                  <td>Country</td>
                  <td>YES</td>
                  <td>Alphabets (3)</td>
                  <td>
                    Country code needs to be passed, Country code as “ARE” for
                    United Arab Emirates . “ITA” for Italy. “USA” for United
                    states of America. “GBR” for Great Britain.
                  </td>
                </tr>

                <tr>
                  <td>Currency</td>
                  <td>YES</td>
                  <td>Alphabets (3)</td>
                  <td>
                    Currency in which you want to process the transaction. AED -
                    Emirati Dirham USD - United States Dollar GBP - Pound
                    Sterling EUR - Euro
                  </td>
                </tr>

                <tr>
                  <td>txn_type</td>
                  <td>YES</td>
                  <td> Alphabets (10)</td>
                  <td>
                    Use Txn_Type as <b> “SALE” </b> which is static witheach
                    request
                  </td>
                </tr>

                <tr>
                  <td>success_url</td>
                  <td>YES</td>
                  <td>
                    Alphanumeric (200) <b>Characters allowed :</b> Alphabet
                    (A-Z), (a-z), Numbers, / (slash), _ (underscore)
                  </td>
                  <td>
                    This will be the return URL where response is accepted for
                    successful transaction.
                  </td>
                </tr>

                <tr>
                  <td>failure_url</td>
                  <td>YES</td>
                  <td>
                    Alphanumeric (200) <b>Characters allowed :</b> Alphabet
                    (A-Z), (a-z) Numbers, / (slash), _ (underscore)
                  </td>
                  <td>
                    This will be the return URL where response is accepted for
                    failed transaction.
                  </td>
                </tr>

                <tr>
                  <td>Channel</td>
                  <td>YES</td>
                  <td>Alphabet (10)</td>
                  <td>
                    Use <b>“WEB”</b> in case of website-based payment or{" "}
                    <b>“MOBILE”</b> in case of mobile app. Static value with
                    each request.
                  </td>
                </tr>
              </tbody>
            </table>

            <table class="table table-bordered">
              <tbody className="table-bdy">
                <tr className="table-main-title">
                  <th colSpan={7}>Section: pg_details</th>
                </tr>
                <tr className="table-color">
                  <th>Parameter Name</th>
                  <th>Mandate</th>
                  <th> Type (length)</th>
                  <th>Description</th>
                </tr>
                <tr>
                  <td>pg_id</td>
                  <td>YES</td>
                  <td>Numeric (11)</td>
                  <td>
                    This is the Bank Identification code assigned by Safexpay
                    Team.
                  </td>
                </tr>

                <tr>
                  <td>Paymode</td>
                  <td>YES</td>
                  <td> Alphabets (2)</td>
                  <td>
                    This is the Paymode Identification code assigned by Safexpay
                    Team
                  </td>
                </tr>

                <tr>
                  <td>Scheme</td>
                  <td>YES</td>
                  <td>Numeric (11)</td>
                  <td>
                    This is the Scheme Identification code assigned by Safexpay
                    Team. For Eg: <b>'1'</b> for Visa, <b> '2'</b> for Master,{" "}
                    <b>'5'</b> for Maestro,
                  </td>
                </tr>

                <tr>
                  <td>emi_months</td>
                  <td>YES</td>
                  <td> Numeric (11)</td>
                  <td>Value must be blank</td>
                </tr>
              </tbody>
            </table>

            <table class="table table-bordered">
              <tbody className="table-bdy">
                <tr className="table-main-title">
                  <th colSpan={7}>Section: card_details</th>
                </tr>
                <tr className="table-color">
                  <th>Parameter Name</th>
                  <th>Mandate</th>
                  <th> Type (length)</th>
                  <th>Description</th>
                </tr>
                <tr>
                  <td>card_no</td>
                  <td>YES</td>
                  <td>Numeric (19)</td>
                  <td>Mandatory, if customer selects the card payments</td>
                </tr>

                <tr>
                  <td>exp_month</td>
                  <td>YES</td>
                  <td> Numeric (2)</td>
                  <td>Mandatory, if customer selects the cardpayments</td>
                </tr>

                <tr>
                  <td>exp_year</td>
                  <td>YES</td>
                  <td>Numeric (4)</td>
                  <td>Mandatory, if customer selects the card payments</td>
                </tr>

                <tr>
                  <td>cvv</td>
                  <td>YES</td>
                  <td> Numeric (3)</td>
                  <td>Mandatory, if customer selects the cardpayments</td>
                </tr>

                <tr>
                  <td>card_name</td>
                  <td>YES</td>
                  <td> Alphabets (50)</td>
                  <td>Mandatory, if customer selects the cardpayments</td>
                </tr>
              </tbody>
            </table>

            <table class="table table-bordered">
              <tbody className="table-bdy">
                <tr className="table-main-title">
                  <th colSpan={7}>Section: cust_details</th>
                </tr>
                <tr className="table-color">
                  <th>Parameter Name</th>
                  <th>Mandate</th>
                  <th> Type (length)</th>
                  <th>Description</th>
                </tr>
                <tr>
                  <td>cust_name</td>
                  <td>YES</td>
                  <td>Alphabets (50)</td>
                  <td>Customer's name is required</td>
                </tr>

                <tr>
                  <td>
                    email_id <b>(Mandatory)</b>{" "}
                  </td>
                  <td>YES</td>
                  <td>
                    Alphanumeric (100) Characters allowed: Alphabet (A-Z),
                    (a-z). Numbers @ (at), dot, _ (underscore)
                  </td>
                  <td>Customer's email id is required</td>
                </tr>

                <tr>
                  <td>
                    mobile_no <b>(Mandatory)</b>
                  </td>
                  <td>YES</td>
                  <td>Numeric (15)</td>
                  <td>Customer's mobile number is required.</td>
                </tr>

                <tr>
                  <td>unique_id</td>
                  <td>NO</td>
                  <td> Alphanumeric (100)</td>
                  <td>
                    This is required in case of <b>Stored card feature.</b>
                  </td>
                </tr>

                <tr>
                  <td>is_logged_in</td>
                  <td>YES</td>
                  <td> Alphabets (1)</td>
                  <td>Pass “Y” if user is logged in</td>
                </tr>
              </tbody>
            </table>

            <table class="table table-bordered">
              <tbody className="table-bdy">
                <tr className="table-main-title">
                  <th colSpan={7}>Section: Bill_details</th>
                </tr>
                <tr className="table-color">
                  <th>Parameter Name</th>
                  <th>Mandate</th>
                  <th> Type (length)</th>
                  <th>Description</th>
                </tr>

                <tr>
                  <td>bill_addres</td>
                  <td>Optional</td>
                  <td>
                    {" "}
                    Alphanumeric (400) <b>Characters allowed:</b> Alphabet
                    (A-Z), (a-z). Numbers # (hash), Comma, circular brackets,
                    /(slash), dot,- (hyphen) Space in between words{" "}
                  </td>
                  <td>
                    Customer’s Billing Address. This is required for fraud
                    protection.
                  </td>
                </tr>

                <tr>
                  <td>bill_city</td>
                  <td>Optional</td>
                  <td>Alphabets (50)</td>
                  <td>
                    Customer's Billing City. This is required required for fraud
                    protection.
                  </td>
                </tr>

                <tr>
                  <td>bill_state</td>
                  <td>Optional</td>
                  <td>Alphabets (50)</td>
                  <td>
                    Customer's Billing State. This is required required for fraud
                    protection.
                  </td>
                </tr>
                <tr>
                  <td>bill_country</td>
                  <td>Optional</td>
                  <td>Alphabets (50)</td>
                  <td>
                    Customer's Billing Country.This is required required for
                    fraud protection.
                  </td>
                </tr>

                <tr>
                  <td>bill_zip</td>
                  <td>Optional</td>
                  <td>
                    {" "}
                    Alphanumeric (20) <b>Characters allowed:</b> Alphabet
                    (A-Z),(a-z). Numbers
                  </td>
                  <td>
                    Customer's Billing Zip/Pin Code.This is required for fraud
                    protection.
                  </td>
                </tr>
              </tbody>
            </table>

            <table class="table table-bordered">
              <tbody className="table-bdy">
                <tr className="table-main-title">
                  <th colSpan={7}>Section: Ship_details</th>
                </tr>
                <tr className="table-color">
                  <th>Parameter Name</th>
                  <th>Mandate</th>
                  <th> Type (length)</th>
                  <th>Description</th>
                </tr>

                <tr>
                  <td>ship_address</td>
                  <td>Optional</td>
                  <td>
                    Alphanumeric (400) <b> Characters allowed:</b> Alphabet
                    (A-Z), (a-z). Numbers # (hash), Comma, circular brackets,
                    /(slash), dot,- (hyphen) Space in between words
                  </td>
                  <td>
                    Customer's Shipping Address. This is required in case of
                    physical delivery of goods.
                  </td>
                </tr>

                <tr>
                  <td>ship_city</td>
                  <td>Optional</td>
                  <td>Alphabets (50)</td>
                  <td>
                    Customer's Shipping City. This is required in case of
                    physical delivery of goods.
                  </td>
                </tr>

                <tr>
                  <td>ship_state</td>
                  <td>Optional</td>
                  <td>Alphabets (50)</td>
                  <td>
                    Customer's Shipping State. This is required in case of
                    physical delivery of goods.
                  </td>
                </tr>

                <tr>
                  <td>ship_country</td>
                  <td>Optional</td>
                  <td>Alphabets (50)</td>
                  <td>
                    Customer’s Shipping Country. This is required in case of
                    physical delivery of goods.
                  </td>
                </tr>

                <tr>
                  <td>ship_zip</td>
                  <td>Optional</td>
                  <td>Alphanumeric (20) <b>Characters allowed:</b> Alphabet (A-Z),(a-z). Numbers{" "}</td>
                  <td>
                    Customer's Shipping Zip/Pin Code. This is required in case
                    of physical delivery of goods.
                  </td>
                </tr>

               

                <tr>
                  <td>ship_days</td>
                  <td>Optional</td>
                  <td>Numeric (11)</td>
                  <td>
                    Approximate number of days required for delivery of goods.
                    This is required in case of physical delivery of goods.
                  </td>
                </tr>

                <tr>
                  <td>address_count</td>
                  <td>Optional</td>
                  <td>Numeric (11)</td>
                  <td>
                    If customer has more than one addresses stored in your
                    system.
                  </td>
                </tr>
              </tbody>
            </table>

            <table class="table table-bordered">
              <tbody className="table-bdy">
                <tr className="table-main-title">
                  <th colSpan={7}>Section: Item_details</th>
                </tr>
                <tr className="table-color">
                  <th>Parameter Name</th>
                  <th>Mandate</th>
                  <th> Type (length)</th>
                  <th>Description</th>
                </tr>

                <tr>
                  <td>item_count</td>
                  <td>Optional</td>
                  <td>Alphanumeric (11)</td>
                  <td>Count of items purchased by customer.</td>
                </tr>

                <tr>
                  <td>item_value</td>
                  <td>Optional</td>
                  <td>Optional (200,2)</td>
                  <td>Comma separated item wise cost</td>
                </tr>

                <tr>
                  <td>item_category</td>
                  <td>Optional</td>
                  <td>Alphanumeric (200)</td>
                  <td>Comma separated item category. E.g., “DVD”</td>
                </tr>
              </tbody>
            </table>

            <table class="table table-bordered">
              <tbody className="table-bdy">
                <tr className="table-main-title">
                  <th colSpan={7}>Section: Other_details</th>
                </tr>
                <tr className="table-color">
                  <th>Parameter Name</th>
                  <th>Mandate</th>
                  <th> Type (length)</th>
                  <th>Description</th>
                </tr>

                <tr>
                  <td>udf_1</td>
                  <td>Optional</td>
                  <td>
                    {" "}
                    Alphanumeric (100) <b>Characters allowed:</b> Alphabet
                    (A-Z), (a-z). Numbers # (hash), Comma, circular
                    brackets,/(slash), dot, -(hyphen) Space in between words
                  </td>
                  <td>
                    This parameter can be used for sending additional
                    information about the transaction. PG will send this
                    parameter in the response.
                  </td>
                </tr>

                <tr>
                  <td>udf_2</td>
                  <td>Optional</td>
                  <td>
                    {" "}
                    Alphanumeric (100) <b>Characters allowed:</b> Alphabet
                    (A-Z), (a-z). Numbers # (hash), Comma, circular
                    brackets,/(slash), dot, -(hyphen) Space in between words
                  </td>
                  <td>
                    This parameter can be used for sending additional
                    information about the transaction. PG will send this
                    parameter in the response.
                  </td>
                </tr>

                <tr>
                  <td>udf_3</td>
                  <td>Optional</td>
                  <td>
                    {" "}
                    Alphanumeric (100) <b>Characters allowed:</b> Alphabet
                    (A-Z), (a-z). Numbers # (hash), Comma, circular
                    brackets,/(slash), dot, -(hyphen) Space in between words
                  </td>
                  <td>
                    This parameter can be used for sending additional
                    information about the transaction. PG will send this
                    parameter in the response.
                  </td>
                </tr>

                <tr>
                  <td>udf_4</td>
                  <td>Optional</td>
                  <td>
                    {" "}
                    Alphanumeric (100) <b>Characters allowed:</b> Alphabet
                    (A-Z), (a-z). Numbers # (hash), Comma, circular
                    brackets,/(slash), dot, -(hyphen) Space in between words
                  </td>
                  <td>
                    This parameter can be used for sending additional
                    information about the transaction. PG will send this
                    parameter in the response.
                  </td>
                </tr>

                <tr>
                  <td>udf_5</td>
                  <td>Optional</td>
                  <td>
                    {" "}
                    Alphanumeric (100) <b>Characters allowed:</b> Alphabet
                    (A-Z), (a-z). Numbers # (hash), Comma, circular
                    brackets,/(slash), dot, -(hyphen) Space in between words
                  </td>
                  <td>
                    This parameter can be used for sending additional
                    information about the transaction. PG will send this
                    parameter in the response.
                  </td>
                </tr>
              </tbody>
            </table>

            <div className="note-div">
              <b className="aggHost-note">Note :</b>
              <p>
              Value in each section will be encrypted value generated in the following way. Only me_id (Merchant ID) will be in plain text. 
              </p>

              <p>
              Each attribute in every section is combined and separated with pipe (|). Make sure that you are sending the request in the
                <b className="para-blod"> HTTP Form post method.</b>
              </p>

              <p className="para-blod">Please find the format shared below:</p>

              <p>
              The transaction request is not compatible with the{" "}
                <span className="highlighter-cusm">Postman Platform.</span>
              </p>

              <p>
              Transactions are only permitted through registered merchant domains. If “localhost” or local IP is not permitted, you will get an
                <b className="para-blod">“Invalid Referral URL.” </b> error in
                such case.
              </p>
             

              <p>
              Transaction requests must be in the manner below when it trigger to our Payment Gateway URL. Merchants must send the following parameters to the Safexpay PG, which is mandatory, but values might be blank if they are optional or not required. 
              </p>

              <p className="para-underline">
              Example of the Transaction request in HTTP Form post method: Sample HTML transaction posting:
              </p>

              <ul>
                <li>
                  Make sure that you are sending the request in the
                  <b className="para-blod"> HTTP Form post method.</b>
                </li>
                <li>
                  Transactions are only permitted through registered merchant
                  domains. If “localhost” or local IP is not permitted, you will
                  get <b className="para-blod">“Invalid Referral URL.” </b>{" "}
                  error.
                </li>
                <li>
                  {" "}
                  Transaction request must be in the manner below when it
                  triggers to our Payment Gateway URL.
                </li>
                <li>
                  {" "}
                  Merchants must send the following parameters to the{" "}
                  <b className="para-blod">Safexpay</b> PG which is mandatory,
                  but values might be blank in case of optional or not required
                </li>
              </ul>

              <p className="para-underline">
                
Please note only HTML Form Submission with the ‘POST’ method is supported. Sending payment requests using any REST API call is not supported. 
              </p>

              <div className="img-div">
                <img src="assets/images/Screenshot-code1.png" alt="logo" />
              </div>

              <div className="prgm-div">
                <p className="para-underline mt-2">
                  Sample Request Before Encryption:
                </p>

                <p>
                  {" "}
                  <b className="para-blod">me_id :</b> 202308230002
                </p>
                <p>
                  <b className="para-blod">merchant request :</b>{" "}
                  paygate|202308230002|30074|16|ARE|AED|SALE|http://localhost/PHP_with_Checksum/t
                  ransactin//Response.php|http://localhost/PHP_with_Checksum/transaction//Response.ph
                  p|WEB~629|CC|2|7~||||~|suchita.khandekar92@gmail.com|08879709339||Y~||||~|||
                  |||~||~~||||
                </p>
                <p>
                  <b className="para-blod">Hash :</b>{" "}
                  0c64c29566b50e385301deee30090e58535ba8650608c61ea69cc5e1e89d61fb
                </p>
              </div>

              <div className="prgm-div">
                <p className="para-underline mt-2">
                  Sample Request After Encryption:
                </p>

                <p>
                  <b className="para-blod">me_id :</b> 202308230002
                </p>
                <p>
                  <b className="para-blod">merchant request :</b>{" "}
                  DvGm+c3oOWRV7NtDHZQvr//tTeLwtPVfKzGakbz6w6JEvMlBP9CdNuSwzeYWDimO/9iZaZ7
                  4PDet8EMitY3QPfb7GQ077TdbEHbDwpOv6c+GjVuzLxw2ouk7uBvPGltcfbU2DJkTXQQBvnyy
                  C2ytWKpzM183bKn86iGSxsbZMPsQQYqH5TmgW6fTUlWKUOMrVVZYiSQYCk72qUBH7DAV
                  q3oh0dV0znf+42IWSDUpms/Nqnnv2KLltFZFH03BvtQkzYRRyXlaig/M0mHUGqybyIw2LHYpI
                  V+twPR4+RS7znu2kgM9auRUgU1e5S+7p9QNLSFOiAMQdzdYYfhb u0bfxQ==
                </p>
                <p>
                  <b className="para-blod">Hash :</b>{" "}
                  0Wzun5tyEJEute57GUrGUia9hUokdMyIne3phaKKcEKiP+RBleED6kvFz9qbSM3Grml+Ecg10/
                  O7j3z+kc2Y97f5 HygedQF7 MsFySzjhdV4=
                </p>

                <p className="para-underline ">
                  Merchant_request will get encrypt by aes256 (Details shared
                  below) :
                </p>

                <p>
                  {" "}
                  <b>
                    $all_values =
                    $txn_details.'~'.$pg_details.'~'.$card_details.'~'.$cust_details.'~'.$bill_details.'~'.$ship_details.'~'.
                    $item_details '~'.$other_details;
                    $merchant_request['merchant_request'] =
                    $aes-encrypt($all_values, $merchant_key, 256);
                  </b>
                </p>
                <p className="para-underline ">Encrypted Response:</p>
                <p>
                  <b className="para-blod">txn_response :</b>{" "}
                  DvGm+c3oOWRV7NtDHZQvr6TavcytA87NYvVC9vIlzMwSa8628SkQBlgfVb+Zx/2LgUkQ1gweLwxBj
                  tOYeRmT5m7XDdq+rClrvDUA9n4qTY5qljAskrUcAMz2FZ5Hodo/9Ufm2lZaR8s+uWbsgyrs0QY00kx
                  wGn2/qejMiNThndr6Cltq1Ibgqw4eyhqKlbah+hA51r7g3ZBH2GroJ0XLUFUPt98OEJSRzUbMVhE5a
                  fxrEfqmWmB77EXEyfzRATnNMYyFfHcht+K1604cA1FEBwXRTzp0kEumNilwVOI9VQx0zY0wkn6v
                  J9cbkDrpfPQ+
                </p>

                <p>
                  <b className="para-blod">me_id: 202308230002</b>
                </p>

                <p>
                  <b className="para-blod">pg_details : </b>
                  pz5VIXq55ZK196AQfqythxqkBM0ymmqdIbpff1gBwbE=
                </p>
                <p>
                  <b className="para-blod">fraud_details : </b>
                  12qAKnsBgzQw4zmIZ8SHFQ==
                </p>
                <p>
                  <b className="para-blod">other_details : </b>
                  f46FM6eFYnnwXDhX3nzJdg==
                </p>

                <p className="para-underline ">Decrypted Response :</p>

                <p>
                  <b className="para-blod">txn_response :</b>{" "}
                  paygate|202308230002|30074|16.00|ARE|AED|2022-01-05|12:24:17.0|107862084937521696
                  4|PG_1078620849375216964|Successful~CzovV+d67CfvbOpCM3vUcwBCv8URzC/X1TzydL8CCuf
                  7f4fZXhToU5GxAqvj1 HxxZqTFJO3/RFQ6PcVYf
                  R7uDiaUQVO1lvNYLlR4jix1APw=~|0|Successful
                </p>

                <p>
                  <b className="para-blod">me_id: 202308230002</b>
                </p>

                <p>
                  <b className="para-blod">pg_details : </b> 629|Test Bank|CC|
                </p>
                <p>
                  <b className="para-blod">fraud_details : </b> |NA|
                </p>
                <p>
                  <b className="para-blod">other_details : </b> ||||NA|||||
                </p>
              </div>

              <h3>Enable Tabby for Merchant Hosted Integration Type :</h3>

              <div className="transaction-request-div mt-3">
                <b className="aggHost-note">Transaction Request :</b>
                <p>
                  Below changes to be made in Transaction request for{" "}
                  <b className="para-blod">Tabby</b> Paymode for Merchant Hosted
                  Integration Type :{" "}
                </p>

                <p className="para-blod">
                  Merchant Hosted Request for BNPL(Buy Now Pay Later) :
                </p>

                <table class="table table-bordered">
                  <tbody className="table-bdy">
                    <tr className="table-main-title">
                      <th colSpan={7}>
                        Section: Txn_Details (Required Parameters)
                      </th>
                    </tr>
                    <tr className="table-color">
                      <th>Parameter Name</th>
                      <th>Mandate</th>
                      <th> Type </th>
                      <th>Character Length</th>
                      <th>Description</th>
                      <th>Dynamic/Static</th>
                      <th> Paymode Specific</th>
                    </tr>

                    <tr>
                      <td>ag_id</td>
                      <td>YES</td>
                      <td>Alphabets</td>
                      <td>11</td>
                      <td>Aggregator id is “paygate”.</td>
                      <td>Static</td>
                      <td></td>
                    </tr>

                    <tr>
                      <td>me_id</td>
                      <td>YES</td>
                      <td>Numeric</td>
                      <td>20</td>
                      <td>Merchant ID issued to merchant by Safexpay</td>
                      <td>Dynamic</td>
                      <td></td>
                    </tr>

                    <tr>
                      <td>order_no</td>
                      <td>YES</td>
                      <td>Alphanumeric</td>
                      <td>20</td>
                      <td>
                        This is unique ID , used by merchants to identify the
                        order.
                      </td>
                      <td>Dynamic</td>
                      <td></td>
                    </tr>

                    <tr>
                      <td>Amount</td>
                      <td>YES</td>
                      <td>Numeric(6 Digits) with 2 decimal values</td>
                      <td>10</td>
                      <td>Transaction Amount</td>
                      <td>Dyanmic</td>
                      <td></td>
                    </tr>

                    <tr>
                      <td>Country</td>
                      <td>YES</td>
                      <td>Alphabhetic</td>
                      <td>3</td>
                      <td>This will provide Country name</td>
                      <td>Dyanmic</td>
                      <td></td>
                    </tr>

                    <tr>
                      <td>Currency</td>
                      <td>YES</td>
                      <td>Alphabhetic</td>
                      <td>3</td>
                      <td>
                        This will provide Currency code (as per International
                        standards ) basically currency in which transation will
                        happen.
                      </td>
                      <td>Dyanmic</td>
                      <td></td>
                    </tr>

                    <tr>
                      <td>txn_type</td>
                      <td>YES</td>
                      <td>Alphabetic</td>
                      <td>10</td>
                      <td>This will provide transaction type - Sale</td>
                      <td>Static</td>
                      <td></td>
                    </tr>

                    <tr>
                      <td>success_urll</td>
                      <td>YES</td>
                      <td>
                        Alphanumeric (200) Characters allowed: Alphabet (A-Z),
                        (a-z), Numbers,/ (slash), _ (underscore)
                      </td>
                      <td>200</td>
                      <td>
                        This will be the return URL where response is accepted
                        for Failed transaction.
                      </td>

                      <td>Dynamic</td>
                      <td></td>
                    </tr>

                    <tr>
                      <td>failure_url</td>
                      <td>YES</td>
                      <td>
                        Alphanumeric (200) Characters allowed: Alphabet (A-Z),
                        (a-z), Numbers,/ (slash), _ (underscore)
                      </td>
                      <td>200</td>
                      <td>
                        This will be the return URL where response is accepted
                        for Success transaction
                      </td>
                      <td>Dynamic</td>
                      <td></td>
                    </tr>

                    <tr>
                      <td>Channel</td>
                      <td>YES</td>
                      <td>Alphabhetic</td>
                      <td>10</td>
                      <td>
                        Use “WEB” in case of website-based payment or “MOBILE”
                        in case of mobile app. Static value with each request
                      </td>
                      <td>Dynamic</td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>

                <table class="table table-bordered">
                  <tbody className="table-bdy">
                    <tr className="table-main-title">
                      <th colSpan={7}>
                        Section: pg_details (Mandatory for Integration type as
                        Merchant Hosted)
                      </th>
                    </tr>
                    <tr className="table-color">
                      <th>Parameter Name</th>
                      <th>Mandate</th>
                      <th> Type </th>
                      <th>Character Length</th>
                      <th>Description</th>
                      <th>Dynamic/Static</th>
                      <th> Paymode Specific</th>
                    </tr>

                    <tr>
                      <td>pg_id</td>
                      <td>YES</td>
                      <td>Numeric</td>
                      <td>No validation</td>
                      <td>
                        This is the Bank Identification code assigned by
                        Safexpay Team only if the Integration type is
                        MerchantHosted (SEAMLESS) otherwise the value must be
                        blank in the request
                      </td>
                      <td>Dynamic</td>
                      <td></td>
                    </tr>

                    <tr>
                      <td>Paymode</td>
                      <td>YES</td>
                      <td>Numeric</td>
                      <td>2</td>
                      <td>
                        This is the Paymode Identification code assigned by
                        Safexpay Team only if the Integration type is Merchant
                        Hosted (SEAMLESS)otherwise the value must be blank in
                        the request
                      </td>
                      <td>Dynamic</td>
                      <td></td>
                    </tr>

                    <tr>
                      <td>Scheme</td>
                      <td>YES</td>
                      <td>Alphabetic</td>
                      <td>11</td>
                      <td>
                        This is the Scheme Identification code assigned by
                        Safexpay Team only if the Integration type is Merchant
                        Hosted (SEAMLESS) otherwise the value must be blank in
                        the request.
                      </td>
                      <td></td>
                      <td></td>
                    </tr>

                    <tr>
                      <td>emi_months</td>
                      <td>NO</td>
                      <td>Numeric</td>
                      <td></td>
                      <td>As of now we are not using this parameter</td>
                      <td></td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>

                <table class="table table-bordered">
                  <tbody className="table-bdy">
                    <tr className="table-main-title">
                      <th colSpan={7}>Section: card_details</th>
                    </tr>
                    <tr className="table-color">
                      <th>Parameter Name</th>
                      <th>Mandate</th>
                      <th> Type </th>
                      <th>Character Length</th>
                      <th>Description</th>
                      <th>Dynamic/Static</th>
                      <th> Paymode Specific</th>
                    </tr>

                    <tr>
                      <td>card_no</td>
                      <td>NO</td>
                      <td>Numeric</td>
                      <td>NO</td>
                      <td>Card number will be</td>
                      <td></td>
                      <td></td>
                    </tr>

                    <tr>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td>validation</td>
                      <td>
                        accepted for merchant hosted integration type and for
                        other paymodes it will be blank
                      </td>
                      <td></td>
                      <td></td>
                    </tr>

                    <tr>
                      <td>exp_month</td>
                      <td>NO</td>
                      <td>Numeric</td>
                      <td>2</td>
                      <td>
                        Expiry Date will be accepted for merchant hosted
                        integration type and for other paymodes it will be blank
                      </td>
                      <td></td>
                      <td></td>
                    </tr>

                    <tr>
                      <td>exp_year</td>
                      <td>NO</td>
                      <td>Numeric</td>
                      <td>4</td>
                      <td>
                        Expiry year will be accepted for merchant hosted
                        integration type and for other paymodes it will be blank{" "}
                      </td>

                      <td></td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>cvv</td>
                      <td>NO</td>
                      <td>Numeric</td>
                      <td>3</td>
                      <td>
                        CVV will be accepted for merchant hosted integration
                        type and for other paymodes it will be blank
                      </td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>card_name</td>
                      <td>NO</td>
                      <td>Numeric</td>
                      <td>50</td>
                      <td>
                        Card name will be accepted for merchant hosted
                        integration type and for other paymodes it will be blank
                      </td>
                      <td></td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>

                <table class="table table-bordered">
                  <tbody className="table-bdy">
                    <tr className="table-main-title">
                      <th colSpan={7}>Section: cust_details</th>
                    </tr>
                    <tr className="table-color">
                      <th>Parameter Name</th>
                      <th>Mandate</th>
                      <th> Type </th>
                      <th>Character Length</th>
                      <th>Description</th>
                      <th>Dynamic/Static</th>
                      <th> Paymode Specific</th>
                    </tr>

                    <tr>
                      <td>cust_name</td>
                      <td>YES</td>
                      <td>Alphabetic</td>
                      <td></td>
                      <td>This will provide customer name </td>
                      <td>Dynamic</td>
                      <td></td>
                    </tr>

                    <tr>
                      <td>
                        email_id <b>(Mandatory)</b>
                      </td>
                      <td>YES</td>
                      <td>
                        Alphanumeric with allowed characters Alphabet (A-Z),
                        (a-z). Numbers @ (at), dot, _ (underscore)
                      </td>
                      <td>100</td>
                      <td>This will provide customer Email </td>
                      <td>Dynamic</td>
                      <td></td>
                    </tr>

                    <tr>
                      <td>
                        mobile_no <b>(Mandatory)</b>
                      </td>
                      <td>YES</td>
                      <td>Numeric</td>
                      <td>15</td>
                      <td>This will provide Customer Mobile Number</td>
                      <td>Dynamic</td>
                      <td></td>
                    </tr>

                    <tr>
                      <td>unique_id</td>
                      <td>NO</td>
                      <td>Numeric</td>
                      <td>100</td>
                      <td>This is required in case of Stored card feature</td>
                      <td>Dynamic</td>
                      <td></td>
                    </tr>

                    <tr>
                      <td>is_logged_in</td>
                      <td>YES</td>
                      <td>Alphabetic</td>
                      <td>1</td>
                      <td>pass"Y" if user is logged in </td>
                      <td>Dynamic</td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>

                <table class="table table-bordered">
                  <tbody className="table-bdy">
                    <tr className="table-main-title">
                      <th colSpan={7}>Section: Bill_details</th>
                    </tr>
                    <tr className="table-color">
                      <th>Parameter Name</th>
                      <th>Mandate</th>
                      <th> Type </th>
                      <th>Character Length</th>
                      <th>Description</th>
                      <th>Dynamic/Static</th>
                      <th> Paymode Specific</th>
                    </tr>

                    <tr>
                      <td>bill_addres</td>
                      <td>YES</td>
                      <td></td>
                      <td>250</td>
                      <td>This will provide</td>
                      <td>Dynamic</td>
                      <td></td>
                    </tr>

                    <tr>
                      <td></td>
                      <td></td>
                      <td>
                        Alphanumeric Characters allowed: Alphabet (A-Z), (a-z).
                        Numbers # (hash), Comma, circular brackets, /(slash),
                        dot,- (hyphen) Space in between words
                      </td>
                      <td></td>
                      <td>customer's Billing address.</td>
                      <td></td>
                      <td></td>
                    </tr>

                    <tr>
                      <td>bill_city</td>
                      <td>YES</td>
                      <td>Alphabetic</td>
                      <td>50</td>
                      <td>This will provide customer's Billing City</td>
                      <td>Dynamic</td>
                      <td></td>
                    </tr>

                    <tr>
                      <td>bill_state</td>
                      <td>YES</td>
                      <td>bill_state</td>
                      <td>50</td>
                      <td>This will provide customer's Billing state</td>
                      <td>Dynamic</td>
                      <td></td>
                    </tr>

                    <tr>
                      <td>bill_country</td>
                      <td>YES</td>
                      <td>Alphabetic</td>
                      <td>50</td>
                      <td>This will provide customer's Billing Country </td>
                      <td>Dynamic</td>
                      <td></td>
                    </tr>

                    <tr>
                      <td>bill_zip</td>
                      <td>YES</td>
                      <td>Numeric</td>
                      <td>10</td>
                      <td>This will provide Customer's Bill zip code</td>
                      <td>Dynamic</td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>

                <table class="table table-bordered">
                  <tbody className="table-bdy">
                    <tr className="table-main-title">
                      <th colSpan={7}>Section: Ship_details</th>
                    </tr>
                    <tr className="table-color">
                      <th>Parameter Name</th>
                      <th>Mandate</th>
                      <th> Type </th>
                      <th>Character Length</th>
                      <th>Description</th>
                      <th>Dynamic/Static</th>
                      <th> Paymode Specific</th>
                    </tr>

                    <tr>
                      <td>ship_address</td>
                      <td>YES</td>
                      <td>
                        Alphanumeric Characters allowed: Alphabet (A-Z), (a-z).
                        Numbers # (hash), Comma, circular brackets, /(slash),
                        dot,- (hyphen) Space in between words
                      </td>
                      <td>250</td>
                      <td>This will provide customer's Billing address.</td>
                      <td>Dynamic</td>
                      <td></td>
                    </tr>

                    <tr>
                      <td>ship_city</td>
                      <td>YES</td>
                      <td>Alphabetic</td>
                      <td>50</td>
                      <td>This will provide customer's Billing City </td>
                      <td>Dynamic</td>
                      <td></td>
                    </tr>

                    <tr>
                      <td>ship_state</td>
                      <td>YES</td>
                      <td>ship_state</td>
                      <td>50</td>
                      <td>This will provide customer's Billing</td>
                      <td>Dynamic</td>
                      <td></td>
                    </tr>

                    <tr>
                      <td>ship_country</td>
                      <td>YES</td>
                      <td>Alphabetic</td>
                      <td>50</td>
                      <td>This will provide customer's Billing Country </td>
                      <td>Dynamic</td>
                      <td></td>
                    </tr>

                    <tr>
                      <td>ship_zip</td>
                      <td>YES</td>
                      <td>Numeric</td>
                      <td>10</td>
                      <td>This will provide Customer's Bill zip code</td>
                      <td>Dynamic</td>
                      <td></td>
                    </tr>

                    <tr>
                      <td>ship_days</td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>

                    <tr>
                      <td>address_count</td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>

                <table class="table table-bordered">
                  <tbody className="table-bdy">
                    <tr className="table-main-title">
                      <th colSpan={7}>Section: Item_details</th>
                    </tr>
                    <tr className="table-color">
                      <th>Parameter Name</th>
                      <th>Mandate</th>
                      <th> Type </th>
                      <th>Character Length</th>
                      <th>Description</th>
                      <th>Dynamic/Static</th>
                      <th> Paymode Specific</th>
                    </tr>

                    <tr>
                      <td>item_count </td>
                      <td>YES</td>
                      <td>Numeric</td>
                      <td></td>
                      <td>This will provide item quantity</td>
                      <td>Dynamic</td>
                      <td></td>
                    </tr>

                    <tr>
                      <td>item_value</td>
                      <td>YES</td>
                      <td>item_value</td>
                      <td></td>
                      <td>This will provide item price </td>
                      <td>Dynamic</td>
                      <td></td>
                    </tr>

                    <tr>
                      <td>item_category</td>
                      <td>YES</td>
                      <td>Alphanumeric</td>
                      <td></td>
                      <td>This will provide item category</td>
                      <td>Dynamic</td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>

                <table class="table table-bordered">
                  <tbody className="table-bdy">
                    <tr className="table-main-title">
                      <th colSpan={7}>Section: Other_details</th>
                    </tr>
                    <tr className="table-color">
                      <th>Parameter Name</th>
                      <th>Mandate</th>
                      <th> Type </th>
                      <th>Character Length</th>
                      <th>Description</th>
                      <th>Dynamic/Static</th>
                      <th> Paymode Specific</th>
                    </tr>

                    <tr>
                      <td>udf_1</td>
                      <td>YES</td>
                      <td>Alphanumeric</td>
                      <td>No validation</td>
                      <td>This will provide item description </td>
                      <td>Dynamic</td>
                      <td></td>
                    </tr>

                    <tr>
                      <td>udf_1</td>
                      <td>YES</td>
                      <td>Alphanumeric</td>
                      <td>No validation</td>
                      <td>This will provide item URL </td>
                      <td>Dynamic</td>
                      <td></td>
                    </tr>

                    <tr>
                      <td>udf_1</td>
                      <td>NO</td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>

                    <tr>
                      <td>udf_1</td>
                      <td>NO</td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>

                    <tr>
                      <td>udf_1</td>
                      <td>NO</td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>

                    <tr>
                      <td>udf_1</td>
                      <td>NO</td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>

                <h3>Enable Tabby for Merchant Hosted Integration Type :</h3>

                <div className="transaction-request-div mt-3">
                  <b className="aggHost-note">Transaction Request :</b>
                  <p>
                    Below changes to be made in Transaction request/simulator
                    for <b className="para-blod"> Tabby, Postpay Paymode </b>
                    for merchant hosted integration Type:
                  </p>

                  <p className="para-blod">
                    Merchant Hosted Request for BNPL(Buy Now Pay Later) :
                  </p>

                  <table class="table table-bordered">
                    <tbody className="table-bdy">
                      <tr className="table-main-title">
                        <th colSpan={7}>
                          Section: Txn_Details (Required Parameters)
                        </th>
                      </tr>
                      <tr className="table-color">
                        <th>Parameter Name</th>
                        <th>Mandate</th>
                        <th> Type </th>
                        <th>Character Length</th>
                        <th>Description</th>
                        <th>Dynamic/Static</th>
                        <th> Paymode Specific</th>
                      </tr>

                      <tr>
                        <td>ag_id</td>
                        <td>YES</td>
                        <td>Alphabets</td>
                        <td>11</td>
                        <td>Aggregator id is “paygate”.</td>
                        <td>Static</td>
                        <td></td>
                      </tr>

                      <tr>
                        <td>me_id</td>
                        <td>YES</td>
                        <td>Numeric</td>
                        <td>20</td>
                        <td>Merchant ID issued to merchant by Safexpay</td>
                        <td>Dynamic</td>
                        <td></td>
                      </tr>

                      <tr>
                        <td>order_no</td>
                        <td>YES</td>
                        <td>Alphanumeric</td>
                        <td>20</td>
                        <td>
                          This is unique ID , used by merchants to identify the
                          order.
                        </td>
                        <td>Dynamic</td>
                        <td></td>
                      </tr>

                      <tr>
                        <td>Amount</td>
                        <td>YES</td>
                        <td>Numeric(6 Digits) with 2 decimal values</td>
                        <td>10</td>
                        <td>Transaction Amount</td>
                        <td>Dyanmic</td>
                        <td></td>
                      </tr>

                      <tr>
                        <td>Country</td>
                        <td>YES</td>
                        <td>Alphabhetic</td>
                        <td>3</td>
                        <td>This will provide Country name</td>
                        <td>Dyanmic</td>
                        <td></td>
                      </tr>

                      <tr>
                        <td>Currency</td>
                        <td>YES</td>
                        <td>Alphabhetic</td>
                        <td>3</td>
                        <td>
                          This will provide Currency code (as per International
                          standards ) basically currency in which transation
                          will happen.
                        </td>
                        <td>Dyanmic</td>
                        <td></td>
                      </tr>

                      <tr>
                        <td>txn_type</td>
                        <td>YES</td>
                        <td>Alphabetic</td>
                        <td>10</td>
                        <td>This will provide transaction type - Sale</td>
                        <td>Static</td>
                        <td></td>
                      </tr>

                      <tr>
                        <td>success_urll</td>
                        <td>YES</td>
                        <td>
                          Alphanumeric (200) Characters allowed: Alphabet (A-Z),
                          (a-z), Numbers,/ (slash), _ (underscore)
                        </td>
                        <td>200</td>
                        <td>
                          This will be the return URL where response is accepted
                          for Failed transaction.
                        </td>

                        <td>Dynamic</td>
                        <td></td>
                      </tr>

                      <tr>
                        <td>failure_url</td>
                        <td>YES</td>
                        <td>
                          Alphanumeric (200) Characters allowed: Alphabet (A-Z),
                          (a-z), Numbers,/ (slash), _ (underscore)
                        </td>
                        <td>200</td>
                        <td>
                          This will be the return URL where response is accepted
                          for Success transaction
                        </td>
                        <td>Dynamic</td>
                        <td></td>
                      </tr>

                      <tr>
                        <td>Channel</td>
                        <td>YES</td>
                        <td>Alphabhetic</td>
                        <td>10</td>
                        <td>
                          Use “WEB” in case of website-based payment or “MOBILE”
                          in case of mobile app. Static value with each request
                        </td>
                        <td>Dynamic</td>
                        <td></td>
                      </tr>
                    </tbody>
                  </table>

                  <table class="table table-bordered">
                    <tbody className="table-bdy">
                      <tr className="table-main-title">
                        <th colSpan={7}>
                          Section: pg_details (Mandatory for Integration type as
                          Merchant Hosted)
                        </th>
                      </tr>
                      <tr className="table-color">
                        <th>Parameter Name</th>
                        <th>Mandate</th>
                        <th> Type </th>
                        <th>Character Length</th>
                        <th>Description</th>
                        <th>Dynamic/Static</th>
                        <th> Paymode Specific</th>
                      </tr>

                      <tr>
                        <td>pg_id</td>
                        <td>YES</td>
                        <td>Numeric</td>
                        <td>No validation</td>
                        <td>
                          This is the Bank Identification code assigned by
                          Safexpay Team only if the Integration type is
                          MerchantHosted (SEAMLESS) otherwise the value must be
                          blank in the request
                        </td>
                        <td>Dynamic</td>
                        <td></td>
                      </tr>

                      <tr>
                        <td>Paymode</td>
                        <td>YES</td>
                        <td>Numeric</td>
                        <td>2</td>
                        <td>
                          This is the Paymode Identification code assigned by
                          Safexpay Team only if the Integration type is Merchant
                          Hosted (SEAMLESS)otherwise the value must be blank in
                          the request
                        </td>
                        <td>Dynamic</td>
                        <td></td>
                      </tr>

                      <tr>
                        <td>Scheme</td>
                        <td>YES</td>
                        <td>Alphabetic</td>
                        <td>11</td>
                        <td>
                          This is the Scheme Identification code assigned by
                          Safexpay Team only if the Integration type is Merchant
                          Hosted (SEAMLESS) otherwise the value must be blank in
                          the request.
                        </td>
                        <td></td>
                        <td></td>
                      </tr>

                      <tr>
                        <td>emi_months</td>
                        <td>NO</td>
                        <td>Numeric</td>
                        <td></td>
                        <td>As of now we are not using this parameter</td>
                        <td></td>
                        <td></td>
                      </tr>
                    </tbody>
                  </table>

                  <table class="table table-bordered">
                    <tbody className="table-bdy">
                      <tr className="table-main-title">
                        <th colSpan={7}>Section: card_details</th>
                      </tr>
                      <tr className="table-color">
                        <th>Parameter Name</th>
                        <th>Mandate</th>
                        <th> Type </th>
                        <th>Character Length</th>
                        <th>Description</th>
                        <th>Dynamic/Static</th>
                        <th> Paymode Specific</th>
                      </tr>

                      <tr>
                        <td>card_no</td>
                        <td>NO</td>
                        <td>Numeric</td>
                        <td>NO</td>
                        <td>Card number will be</td>
                        <td></td>
                        <td></td>
                      </tr>

                      <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td>validation</td>
                        <td>
                          accepted for merchant hosted integration type and for
                          other paymodes it will be blank
                        </td>
                        <td></td>
                        <td></td>
                      </tr>

                      <tr>
                        <td>exp_month</td>
                        <td>NO</td>
                        <td>Numeric</td>
                        <td>2</td>
                        <td>
                          Expiry Date will be accepted for merchant hosted
                          integration type and for other paymodes it will be
                          blank
                        </td>
                        <td></td>
                        <td></td>
                      </tr>

                      <tr>
                        <td>exp_year</td>
                        <td>NO</td>
                        <td>Numeric</td>
                        <td>4</td>
                        <td>
                          Expiry year will be accepted for merchant hosted
                          integration type and for other paymodes it will be
                          blank{" "}
                        </td>

                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                        <td>cvv</td>
                        <td>NO</td>
                        <td>Numeric</td>
                        <td>3</td>
                        <td>
                          CVV will be accepted for merchant hosted integration
                          type and for other paymodes it will be blank
                        </td>
                        <td></td>
                        <td></td>
                      </tr>
                      <tr>
                        <td>card_name</td>
                        <td>NO</td>
                        <td>Numeric</td>
                        <td>50</td>
                        <td>
                          Card name will be accepted for merchant hosted
                          integration type and for other paymodes it will be
                          blank
                        </td>
                        <td></td>
                        <td></td>
                      </tr>
                    </tbody>
                  </table>

                  <table class="table table-bordered">
                    <tbody className="table-bdy">
                      <tr className="table-main-title">
                        <th colSpan={7}>Section: cust_details</th>
                      </tr>
                      <tr className="table-color">
                        <th>Parameter Name</th>
                        <th>Mandate</th>
                        <th> Type </th>
                        <th>Character Length</th>
                        <th>Description</th>
                        <th>Dynamic/Static</th>
                        <th> Paymode Specific</th>
                      </tr>

                      <tr>
                        <td>cust_name</td>
                        <td>YES</td>
                        <td>Alphabetic</td>
                        <td></td>
                        <td>This will provide customer name </td>
                        <td>Dynamic</td>
                        <td></td>
                      </tr>

                      <tr>
                        <td>
                          email_id <b>(Mandatory)</b>
                        </td>
                        <td>YES</td>
                        <td>
                          Alphanumeric with allowed characters Alphabet (A-Z),
                          (a-z). Numbers @ (at), dot, _ (underscore)
                        </td>
                        <td>100</td>
                        <td>This will provide customer Email </td>
                        <td>Dynamic</td>
                        <td></td>
                      </tr>

                      <tr>
                        <td>
                          mobile_no <b>(Mandatory)</b>
                        </td>
                        <td>YES</td>
                        <td>Numeric</td>
                        <td>15</td>
                        <td>This will provide Customer Mobile Number</td>
                        <td>Dynamic</td>
                        <td></td>
                      </tr>

                      <tr>
                        <td>unique_id</td>
                        <td>NO</td>
                        <td>Numeric</td>
                        <td>100</td>
                        <td>This is required in case of Stored card feature</td>
                        <td>Dynamic</td>
                        <td></td>
                      </tr>

                      <tr>
                        <td>is_logged_in</td>
                        <td>YES</td>
                        <td>Alphabetic</td>
                        <td>1</td>
                        <td>pass"Y" if user is logged in </td>
                        <td>Dynamic</td>
                        <td></td>
                      </tr>
                    </tbody>
                  </table>

                  <table class="table table-bordered">
                    <tbody className="table-bdy">
                      <tr className="table-main-title">
                        <th colSpan={7}>Section: Bill_details</th>
                      </tr>
                      <tr className="table-color">
                        <th>Parameter Name</th>
                        <th>Mandate</th>
                        <th> Type </th>
                        <th>Character Length</th>
                        <th>Description</th>
                        <th>Dynamic/Static</th>
                        <th> Paymode Specific</th>
                      </tr>

                      <tr>
                        <td>bill_addres</td>
                        <td>YES</td>
                        <td></td>
                        <td>250</td>
                        <td>This will provide</td>
                        <td>Dynamic</td>
                        <td></td>
                      </tr>

                      <tr>
                        <td></td>
                        <td></td>
                        <td>
                          Alphanumeric Characters allowed: Alphabet (A-Z),
                          (a-z). Numbers # (hash), Comma, circular brackets,
                          /(slash), dot,- (hyphen) Space in between words
                        </td>
                        <td></td>
                        <td>customer's Billing address.</td>
                        <td></td>
                        <td></td>
                      </tr>

                      <tr>
                        <td>bill_city</td>
                        <td>YES</td>
                        <td>Alphabetic</td>
                        <td>50</td>
                        <td>This will provide customer's Billing City</td>
                        <td>Dynamic</td>
                        <td></td>
                      </tr>

                      <tr>
                        <td>bill_state</td>
                        <td>YES</td>
                        <td>bill_state</td>
                        <td>50</td>
                        <td>This will provide customer's Billing state</td>
                        <td>Dynamic</td>
                        <td></td>
                      </tr>

                      <tr>
                        <td>bill_country</td>
                        <td>YES</td>
                        <td>Alphabetic</td>
                        <td>50</td>
                        <td>This will provide customer's Billing Country </td>
                        <td>Dynamic</td>
                        <td></td>
                      </tr>

                      <tr>
                        <td>bill_zip</td>
                        <td>YES</td>
                        <td>Numeric</td>
                        <td>10</td>
                        <td>This will provide Customer's Bill zip code</td>
                        <td>Dynamic</td>
                        <td></td>
                      </tr>
                    </tbody>
                  </table>

                  <table class="table table-bordered">
                    <tbody className="table-bdy">
                      <tr className="table-main-title">
                        <th colSpan={7}>Section: Ship_details</th>
                      </tr>
                      <tr className="table-color">
                        <th>Parameter Name</th>
                        <th>Mandate</th>
                        <th> Type </th>
                        <th>Character Length</th>
                        <th>Description</th>
                        <th>Dynamic/Static</th>
                        <th> Paymode Specific</th>
                      </tr>

                      <tr>
                        <td>ship_address</td>
                        <td>YES</td>
                        <td>
                          Alphanumeric Characters allowed: Alphabet (A-Z),
                          (a-z). Numbers # (hash), Comma, circular brackets,
                          /(slash), dot,- (hyphen) Space in between words
                        </td>
                        <td>250</td>
                        <td>This will provide customer's Billing address.</td>
                        <td>Dynamic</td>
                        <td></td>
                      </tr>

                      <tr>
                        <td>ship_city</td>
                        <td>YES</td>
                        <td>Alphabetic</td>
                        <td>50</td>
                        <td>This will provide customer's Billing City </td>
                        <td>Dynamic</td>
                        <td></td>
                      </tr>

                      <tr>
                        <td>ship_state</td>
                        <td>YES</td>
                        <td>ship_state</td>
                        <td>50</td>
                        <td>This will provide customer's Billing</td>
                        <td>Dynamic</td>
                        <td></td>
                      </tr>

                      <tr>
                        <td>ship_country</td>
                        <td>YES</td>
                        <td>Alphabetic</td>
                        <td>50</td>
                        <td>This will provide customer's Billing Country </td>
                        <td>Dynamic</td>
                        <td></td>
                      </tr>

                      <tr>
                        <td>ship_zip</td>
                        <td>YES</td>
                        <td>Numeric</td>
                        <td>10</td>
                        <td>This will provide Customer's Bill zip code</td>
                        <td>Dynamic</td>
                        <td></td>
                      </tr>

                      <tr>
                        <td>ship_days</td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>

                      <tr>
                        <td>address_count</td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                    </tbody>
                  </table>

                  <table class="table table-bordered">
                    <tbody className="table-bdy">
                      <tr className="table-main-title">
                        <th colSpan={7}>Section: Item_details</th>
                      </tr>
                      <tr className="table-color">
                        <th>Parameter Name</th>
                        <th>Mandate</th>
                        <th> Type </th>
                        <th>Character Length</th>
                        <th>Description</th>
                        <th>Dynamic/Static</th>
                        <th> Paymode Specific</th>
                      </tr>

                      <tr>
                        <td>item_count </td>
                        <td>YES</td>
                        <td>Numeric</td>
                        <td></td>
                        <td>This will provide item quantity</td>
                        <td>Dynamic</td>
                        <td></td>
                      </tr>

                      <tr>
                        <td>item_value</td>
                        <td>YES</td>
                        <td>item_value</td>
                        <td></td>
                        <td>This will provide item price </td>
                        <td>Dynamic</td>
                        <td></td>
                      </tr>

                      <tr>
                        <td>item_category</td>
                        <td>YES</td>
                        <td>Alphanumeric</td>
                        <td></td>
                        <td>This will provide item category</td>
                        <td>Dynamic</td>
                        <td></td>
                      </tr>
                    </tbody>
                  </table>

                  <table class="table table-bordered">
                    <tbody className="table-bdy">
                      <tr className="table-main-title">
                        <th colSpan={7}>Section: Other_details</th>
                      </tr>
                      <tr className="table-color">
                        <th>Parameter Name</th>
                        <th>Mandate</th>
                        <th> Type </th>
                        <th>Character Length</th>
                        <th>Description</th>
                        <th>Dynamic/Static</th>
                        <th> Paymode Specific</th>
                      </tr>

                      <tr>
                        <td>udf_1</td>
                        <td>YES</td>
                        <td>Alphanumeric</td>
                        <td>No validation</td>
                        <td>This will provide item description </td>
                        <td>Dynamic</td>
                        <td></td>
                      </tr>

                      <tr>
                        <td>udf_1</td>
                        <td>YES</td>
                        <td>Alphanumeric</td>
                        <td>No validation</td>
                        <td>This will provide item URL </td>
                        <td>Dynamic</td>
                        <td></td>
                      </tr>

                      <tr>
                        <td>udf_1</td>
                        <td>NO</td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>

                      <tr>
                        <td>udf_1</td>
                        <td>NO</td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>

                      <tr>
                        <td>udf_1</td>
                        <td>NO</td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>

                      <tr>
                        <td>udf_1</td>
                        <td>NO</td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4"></div>
        </div>
      </div>
    </div>
  );
}
export default MerchantHostedSeamless;
